import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedPercentage } from 'intl/LocalizedComponents';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Custom
import { listRowSpecsShape, cpmServiceFeeRuleShape } from 'constants/PropTypesShapes';
import { CarparksContainedButton } from 'components/buttons/ContainedButtons';
import { EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import Amount from 'components/finance/Amount';

const ServiceFeeRuleRow = React.forwardRef(
  ({
    onDeleteServiceFeeRule, onShowCarparks, onUpdateServiceFeeRule, rowSpecs, serviceFeeRule,
  }, ref) => {
    const handleDeleteServiceFeeRule = () => {
      onDeleteServiceFeeRule(serviceFeeRule);
    };

    const handleShowCarparks = () => {
      onShowCarparks(serviceFeeRule.id);
    };

    const handleUpdateServiceFeeRule = () => {
      onUpdateServiceFeeRule(serviceFeeRule);
    };

    return (
      <TableRow
        ref={ref}
        element={serviceFeeRule}
        rowSpecs={rowSpecs}
        actions={[
          onUpdateServiceFeeRule && <EditIconButton key="bEdit" onClick={handleUpdateServiceFeeRule} />,
          onDeleteServiceFeeRule && <DeleteIconButton key="bDelete" onClick={handleDeleteServiceFeeRule} />,
        ]}
      >
        {/* ----- Name ----- */}
        <TableCell>
          <TruncatedTooltipText>{serviceFeeRule.name}</TruncatedTooltipText>
        </TableCell>
        {/* ----- Value ----- */}
        <TableCell>
          <LocalizedPercentage percentage={serviceFeeRule.value} />
        </TableCell>
        {/* ----- Price threshold ----- */}
        <TableCell><Amount amount={serviceFeeRule.priceThreshold} /></TableCell>
        {/* ----- Minimum amount ----- */}
        <TableCell><Amount amount={serviceFeeRule.minimumAmount * 100 || serviceFeeRule.minimumAmount} /></TableCell>
        {/* ----- Maximum amount ----- */}
        <TableCell><Amount amount={serviceFeeRule.maximumAmount * 100 || serviceFeeRule.maximumAmount} /></TableCell>
        {/* ----- Carparks ----- */}
        {onShowCarparks && (
          <TableCell noPadding>
            <CarparksContainedButton onClick={handleShowCarparks} />
          </TableCell>
        )}
      </TableRow>
    );
  },
);

ServiceFeeRuleRow.displayName = 'ServiceFeeRuleRow';

ServiceFeeRuleRow.propTypes = {
  onDeleteServiceFeeRule: PropTypes.func,
  onShowCarparks: PropTypes.func,
  onUpdateServiceFeeRule: PropTypes.func,
  rowSpecs: listRowSpecsShape.isRequired,
  serviceFeeRule: cpmServiceFeeRuleShape.isRequired,
};

ServiceFeeRuleRow.defaultProps = {
  onDeleteServiceFeeRule: null,
  onShowCarparks: null,
  onUpdateServiceFeeRule: null,
};

module.exports = ServiceFeeRuleRow;



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/serviceFeeRule/ServiceFeeRuleRow.js